module.exports = __webpack_public_path__ + "img/coding-dark.86615769.svg";